import React, { Component } from 'react'
import styled from 'styled-components'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import {
  Button,
  Colors,
  Pagination,
  TextIcon,
  Title,
} from 'advenio-components'

import UnvalidatedPhotosActions from '../../Data/Redux/UnvalidatedPhotosRedux'

const Container = styled.div`
  padding: 32px;
`
const PageContainer = styled.div`
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const PhotoGalleryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const PhotoCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-bottom: 16px;
  padding: 16px;
  background-color: ${Colors.white500};
  border: 1px solid ${Colors.gray300};
  border-radius: 4px;
`
const PhotoGalleryGrid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 50%;

  &:nth-child(odd) {
    ${PhotoCard} {
      margin-right: 16px;
    }
  }
`
const PhotoContainer = styled.div`
  height: 100%;
  width: 100%;
`
const Photo = styled.img`
  height: 100%;
  width: 100%;
`
const PhotoDetails = styled.div`
  width: 100%;
  padding: 8px 0;
`
const MetaData = styled.p`
  margin: 0;
  color: ${Colors.gray500};
  font-size: 12px;
`
const StudentName = styled.p`
  margin: 4px 0;
  color: ${Colors.gray900};
  font-weight: bold;
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 auto;
  width: 100%;
  margin-top: 8px;
`
const ValidatedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`

class UnvalidatedPhotos extends Component {
  state = {
    pageSelected: 1,
    queryParams: {},
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)

    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }

    this.setState({ queryParams })

    this.props.getUnvalidatedPhotos({ ...queryParams })
  }

  handleDeletePhoto = studentId => () => this.props.deletePhoto(studentId)

  handleValidatePhoto = studentId => () => this.props.validatePhoto(studentId)

  handleClickPaginationLink = (pageSelected) => {
    this.setState({ pageSelected }, () => {
      const queries = { page: pageSelected }

      this.props.getUnvalidatedPhotos(queries)
      this.props.goTo(`?${queryString.stringify(queries)}`)
    })
  }

  goTo = e => this.props.goTo(e.currentTarget.id)

  renderPhotoActions = (photo) => {
    if (photo.deleted_at) {
      return (
        <ValidatedText
          label="Borrada"
          iconType="checkmark"
          iconViewBox="0 1 18 18"
          iconColor={Colors.red500}
        />
      )
    }

    if (photo.validated_at) {
      return (
        <ValidatedText
          label="Validada"
          iconType="checkmark"
          iconViewBox="0 1 18 18"
          iconColor={Colors.green500}
        />
      )
    }

    return (
      <ButtonsContainer>
        <Button
          success
          small
          onClick={this.handleValidatePhoto(photo.id)}
        >
          Validar
        </Button>
        <Button
          danger
          small
          onClick={this.handleDeletePhoto(photo.id)}
        >
          Borrar
        </Button>
      </ButtonsContainer>
    )
  }

  render() {
    const {
      meta,
    } = this.props
    const {
      pageSelected,
    } = this.state

    return (
      <Container>
        <HeaderContainer>
          <Title style={{ marginRight: '16px' }}>Validación de Fotos</Title>
        </HeaderContainer>
        <PageContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.handleClickPaginationLink}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          <PhotoGalleryContainer>
            {this.props.unvalidatedPhotos.map(photo => (
              <PhotoGalleryGrid key={photo.id}>
                <PhotoCard>
                  <PhotoContainer>
                    <Photo src={photo.path} />
                  </PhotoContainer>
                  <PhotoDetails>
                    <MetaData>{photo.registered_by.full_name}</MetaData>
                    <StudentName>{photo.student.full_name}</StudentName>
                    <MetaData>{moment(photo.created_at).format('DD MMMM YYYY').toUpperCase()}</MetaData>
                  </PhotoDetails>
                  {this.renderPhotoActions(photo)}
                </PhotoCard>
              </PhotoGalleryGrid>
            ))}
          </PhotoGalleryContainer>
        </PageContainer>
      </Container>
    )
  }
}

UnvalidatedPhotos.propTypes = {
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** Meta data for the paginated results */
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** React router location information, containing query params etc. */
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** The listing of unvalidated photos */
  unvalidatedPhotos: PropTypes.array,

  /** Submit a request to the API to delete a specified photo */
  deletePhoto: PropTypes.func.isRequired,
  /** Fetch the listing of unvalidated photos from the API */
  getUnvalidatedPhotos: PropTypes.func.isRequired,
  /** Navigate to the given URI */
  goTo: PropTypes.func.isRequired,
  /** Submit a request to the API to mark a given photo as validated */
  validatePhoto: PropTypes.func.isRequired,
}

UnvalidatedPhotos.defaultProps = {
  location: {},
  meta: {},
  unvalidatedPhotos: [],
}

const mapStateToProps = ({ unvalidatedPhotos, ...state }) => ({
  loading: unvalidatedPhotos.get.fetching,
  meta: unvalidatedPhotos.get.results.meta,
  unvalidatedPhotos: unvalidatedPhotos.get.results.data,
  user: state.auth.user,
})

const mapDispatchToProps = dispatch => ({
  deletePhoto: id => dispatch(UnvalidatedPhotosActions.deleteRequest(id)),
  getUnvalidatedPhotos: query => dispatch(UnvalidatedPhotosActions.getRequest(query)),
  validatePhoto: id => dispatch(UnvalidatedPhotosActions.validateRequest(id)),
  goTo: path => dispatch(push(path)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UnvalidatedPhotos))



// WEBPACK FOOTER //
// ./src/Containers/PhotoValidations/UnvalidatedPhotos.jsx